/**
 * Constantes compartilhadas entre as telas de Plano Modelo, Atividades e
 * snapshots PlanoPMOC. Espelham as listas de choices do backend
 * (apps/pmoc/models.py + apps/equipamentos/models.py).
 */

import type {
  CriterioMedicao,
  ExigenciaFoto,
  PeriodicidadeAtividade,
  TipoART,
  TipoPlano,
} from '../../types/pmocPlanos'

export const TIPOS_PLANO: Array<{ value: TipoPlano; label: string }> = [
  { value: 'equipamento', label: 'Equipamento' },
  { value: 'ambiente', label: 'Ambiente / Área / Site' },
]

export const CATEGORIAS_PLANO: Array<{ value: string; label: string }> = [
  { value: 'preventiva', label: 'Preventiva' },
  { value: 'corretiva', label: 'Corretiva' },
  { value: 'higienizacao', label: 'Higienização' },
  { value: 'qai', label: 'Qualidade do Ar Interior' },
  { value: 'sala_tecnica', label: 'Sala Técnica' },
  { value: 'dutos', label: 'Dutos' },
  { value: 'pressurizacao', label: 'Pressurização' },
  { value: 'grelhas_difusores', label: 'Grelhas e Difusores' },
  { value: 'outra', label: 'Outra' },
]

export const ORIGENS_PLANO: Array<{ value: string; label: string }> = [
  { value: 'padrao_sistema', label: 'Padrão do Sistema' },
  { value: 'copiado', label: 'Copiado' },
  { value: 'personalizado', label: 'Personalizado' },
]

export const PERIODICIDADES: Array<{
  value: PeriodicidadeAtividade
  label: string
}> = [
  { value: 'diaria', label: 'Diária' },
  { value: 'semanal', label: 'Semanal' },
  { value: 'quinzenal', label: 'Quinzenal' },
  { value: 'mensal', label: 'Mensal' },
  { value: 'bimestral', label: 'Bimestral' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'semestral', label: 'Semestral' },
  { value: 'anual', label: 'Anual' },
  { value: 'customizada_dias', label: 'Customizada (dias)' },
]

export const TIPOS_EQUIPAMENTO: Array<{ value: string; label: string }> = [
  { value: 'split_hi_wall', label: 'Split Hi-Wall' },
  { value: 'split_cassete', label: 'Split Cassete' },
  { value: 'split_piso_teto', label: 'Split Piso-Teto' },
  { value: 'split_duto', label: 'Split Dutado' },
  { value: 'vrf_condensadora', label: 'VRF Condensadora' },
  { value: 'vrf_evaporadora', label: 'VRF Evaporadora' },
  { value: 'chiller', label: 'Chiller' },
  { value: 'self_contained', label: 'Self-Contained' },
  { value: 'uta', label: 'UTA' },
  { value: 'fancoil', label: 'Fan Coil' },
  { value: 'torre_resfriamento', label: 'Torre de Resfriamento' },
  { value: 'condensadora_ar', label: 'Condensadora a Ar' },
  { value: 'janela', label: 'Ar de Janela' },
  { value: 'ptac', label: 'PTAC' },
  { value: 'outro', label: 'Outro' },
]

export const EXIGENCIAS_FOTO: Array<{ value: ExigenciaFoto; label: string }> = [
  { value: 'nunca', label: 'Nunca' },
  { value: 'opcional', label: 'Opcional' },
]

export const CRITERIOS_MEDICAO: Array<{
  value: CriterioMedicao
  label: string
  ajuda: string
}> = [
  { value: 'apenas_registrar', label: 'Apenas registrar', ajuda: 'sem valores de referência' },
  { value: 'maior_que', label: 'Maior que', ajuda: 'mínimo aceito' },
  { value: 'maior_ou_igual', label: 'Maior ou igual a', ajuda: 'mínimo inclusivo aceito' },
  { value: 'menor_que', label: 'Menor que', ajuda: 'máximo aceito' },
  { value: 'menor_ou_igual', label: 'Menor ou igual a', ajuda: 'máximo inclusivo aceito' },
  { value: 'igual_a', label: 'Igual a', ajuda: 'valor de referência ± tolerância' },
  { value: 'entre', label: 'Entre (faixa)', ajuda: 'mínimo + máximo aceitos' },
]

export const TIPOS_ART: Array<{ value: TipoART; label: string }> = [
  { value: 'planejamento', label: 'Planejamento' },
  { value: 'execucao', label: 'Execução' },
  { value: 'qai', label: 'QAI' },
  { value: 'desinfeccao', label: 'Desinfecção' },
  { value: 'outro', label: 'Outro' },
]

export const STATUS_OCORRENCIA: Array<{ value: string; label: string; cor: string }> = [
  { value: 'pendente', label: 'Pendente', cor: '#90A4AE' },
  { value: 'em_execucao', label: 'Em execução', cor: '#1565C0' },
  { value: 'cumprida', label: 'Cumprida', cor: '#2E7D32' },
  { value: 'cumprida_parcial', label: 'Cumprida parcial', cor: '#F9A825' },
  { value: 'nao_cumprida', label: 'Não cumprida', cor: '#C62828' },
  { value: 'cancelada', label: 'Cancelada', cor: '#757575' },
]

export function labelDe(
  valor: string | null | undefined,
  opcoes: Array<{ value: string; label: string }>,
): string {
  if (!valor) return '—'
  return opcoes.find((o) => o.value === valor)?.label ?? valor
}
